import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function AddRenewableEnergyOfficials() {
  const { id: renergy_id } = useParams(); // ✅ get renergy_id from URL param

  const [formData, setFormData] = useState({
    designation: '',
    officials_name: '',
    officials_email: '',
    phone_number: '',
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  // ✅ Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ✅ Validation
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.designation.trim()) {
      tempErrors.designation = 'Designation is required.';
      isValid = false;
    }
    if (!formData.officials_name.trim()) {
      tempErrors.officials_name = "Official's name is required.";
      isValid = false;
    }
    if (formData.officials_email && !/\S+@\S+\.\S+/.test(formData.officials_email)) {
      tempErrors.officials_email = 'Enter a valid email address.';
      isValid = false;
    }
    if (formData.phone_number && !/^[0-9]{10}$/.test(formData.phone_number)) {
      tempErrors.phone_number = 'Enter a valid 10-digit phone number.';
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  // ✅ Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      // 🧩 Use API route structure that matches your backend controller
      const res = await axios.post(
        `https://backend-zkgn.onrender.com/api/renewable_officials/add/${renergy_id}`,
        formData
      );

      setSuccessMessage('Renewable Energy Official Added Successfully!');
      setErrors({});
      setFormData({
        designation: '',
        officials_name: '',
        officials_email: '',
        phone_number: '',
      });

      // Hide success message after 3 seconds
      setTimeout(() => setSuccessMessage(''), 3000);

      console.log('✅ Official Added:', res.data);
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrors({ api: 'Failed to add official. Please try again.' });
    }
  };

  return (
    <div className="container my-5">
      <h4 className="mb-4 text-center">Add Renewable Energy Official</h4>

      {successMessage && (
        <div className="alert alert-success text-center" role="alert">
          {successMessage}
        </div>
      )}

      {errors.api && (
        <div className="alert alert-danger text-center" role="alert">
          {errors.api}
        </div>
      )}

      <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        <div className="row g-3">
          {/* Designation */}
          <div className="col-md-6">
            <label className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
            />
            {errors.designation && <small className="text-danger">{errors.designation}</small>}
          </div>

          {/* Official's Name */}
          <div className="col-md-6">
            <label className="form-label">Official's Name</label>
            <input
              type="text"
              className="form-control"
              name="officials_name"
              value={formData.officials_name}
              onChange={handleChange}
            />
            {errors.officials_name && <small className="text-danger">{errors.officials_name}</small>}
          </div>

          {/* Email */}
          <div className="col-md-6">
            <label className="form-label">Official's Email (Optional)</label>
            <input
              type="email"
              className="form-control"
              name="officials_email"
              value={formData.officials_email}
              onChange={handleChange}
            />
            {errors.officials_email && <small className="text-danger">{errors.officials_email}</small>}
          </div>

          {/* Phone Number */}
          <div className="col-md-6">
            <label className="form-label">Phone Number (Optional)</label>
            <input
              type="text"
              className="form-control"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
            />
            {errors.phone_number && <small className="text-danger">{errors.phone_number}</small>}
          </div>
        </div>

        {/* Submit */}
        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary px-4">
            Add Renewable Energy Official
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddRenewableEnergyOfficials;
